import { LeadFormHalfMobPreloader } from '@rst/ui-ts'
import React from 'react'
import styled from 'styled-components'

export const LeadFormHalfMob = ({ data }: any) => {
	return (
		<Wrapper align={data.align}>
			<LeadFormHalfMobPreloader {...data} />
		</Wrapper>
	)
}

const Wrapper = styled.div<{ align: string }>`
	display: flex;
	justify-content: flex-start;
	max-width: unset;
	flex-direction: ${p => (p.align === 'left' ? 'column-reverse' : 'column')};
`
